document.addEventListener("DOMContentLoaded", () => {
    const headings = document.querySelectorAll(".cv-component-faq .cv-faq-heading");
    const menu = document.getElementById("faq-menu");
    const searchInput = document.getElementById("faq-menu-search");
    const questions = document.querySelectorAll(".cv-faq-question");

    console.log('headings : ', headings);
    console.log('questions : ', questions);

    initMenu(headings, menu);
    initSearch(searchInput, questions, headings);
});

function initMenu(headings, menu) {
    headings.forEach((heading, index) => {
        const id = `heading-${index}`;
        heading.id = id;

        const listItem = createMenuItem(id, heading.textContent);
        menu.appendChild(listItem);
    });
}

function createMenuItem(id, text) {
    const li = document.createElement("li");
    const a = document.createElement("a");
    a.href = `#${id}`;
    a.textContent = formatText(text);
    a.classList.add(
        "tw-transition-colors",
        "tw-duration-500",
        "tw-block",
        "tw-w-fit",
        "tw-whitespace-nowrap",
        "tw-text-black",
        "hover:tw-text-light-green",
        "tw-text-label",
        "tw-font-medium",
        "tw-px-4",
        "tw-py-2",
        "tw-bg-very-light-green",
        "hover:tw-bg-dark-green",
        "tw-uppercase",
        "tw-rounded-md",
      );
    a.addEventListener("click", (event) => smoothScroll(event, id));
    
    li.appendChild(a);
    return li;
}

function smoothScroll(event, id) {
    event.preventDefault();
    const target = document.getElementById(id);
    const offset = 250;
    const targetPosition = target.getBoundingClientRect().top + window.scrollY - offset;
    window.scrollTo({ top: targetPosition, behavior: "smooth" });
}

function initSearch(searchInput, questions, headings) {
    searchInput.addEventListener("input", () => {
        const query = searchInput.value.toLowerCase();
        filterQuestionsHeadings(questions, query, headings);
        toggleSectionsVisibility(headings);
    });
}

function filterQuestionsHeadings(questions, query, headings) {
    questions.forEach(question => {
        const text = question.textContent.toLowerCase();
        const parentContainer = question.closest(".cv-faq-items");
        parentContainer.style.display = text.includes(query) ? "block" : "none";
    });

    headings.forEach(heading => {
        const text = heading.textContent.toLowerCase();
        const section = heading.closest(".shopify-section");
        if (!section) return;

        const titleMatches = text.includes(query);
        const questionContainers = section.querySelectorAll(".cv-faq-items");

        if (titleMatches) {
            section.style.display = "block";
            questionContainers.forEach(container => {
                container.style.display = "block";
            });
        } else {
            const visibleQuestions = [...questionContainers].some(container => container.style.display !== "none");
            section.style.display = visibleQuestions ? "block" : "none";
        }
    });
}

function toggleSectionsVisibility(headings) {
    headings.forEach((heading) => {
        const faqSection = heading.closest(".cv-component-faq");
        if (!faqSection) return;

        const allHidden = [...faqSection.querySelectorAll(".cv-faq-question")].every(question => {
            const parent = question.closest(".cv-faq-items");
            return window.getComputedStyle(parent).display === "none";
        });

        heading.closest(".shopify-section").style.display = allHidden ? "none" : "block";
    });
}

function formatText(text) {
    text = text.toLowerCase().trim();
    return text.charAt(0).toUpperCase() + text.slice(1);
}